export const environment = {
  production: true,
  motherShipTenant: 'staging.saasmax.com',
  tawk_to: 'https://tawk.to/chat/57b613ece90bf561a3451a03/default/?$_tawk_popout=true',
  ipGeoLocationUrl: 'https://api.ipgeolocation.io/ipgeo?apiKey=d9d46f08bfb34ee59e4e8c74f' +
  '07bb449&fields=country_code2,state_prov,country_name,city,zipcode,country_name',
  partnerEmail: 'partnersuccess@saasmax.com',
  logUrl: 'https://s3.amazonaws.com/saasmaxstaging/',
  logoName: '/logo.jpg'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts